import { ReactNode, memo, HTMLProps, FunctionComponent } from 'react';
import cn from 'classnames'
import './text.stye.scss'

export interface TextProps extends Omit<HTMLProps<HTMLParagraphElement>, 'size'> {
  /**
   * Sets the type of element
   */
  as?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  /**
   * Sets the block of the component
   */
  block?: boolean
  /**
   * Sets the children of element
   */
  children?: ReactNode
  /**
   * Sets the className of the element
   */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

const TextComponent = ({
  size,
  block,
  children,
  className,
  as = 'span',
  ...restProps
}: TextProps) => {
  const Component = as

  const classWrapper = cn ( className, {
    'legion-text': true,
    'legion-text--block': block,
    [`legion-text--${size || as}`]: true,
  })

  return (
    <Component {...restProps} className={classWrapper}>
      {children}
    </Component>
  ) as HTMLProps<HTMLParagraphElement>
}

export const Text = memo(TextComponent as FunctionComponent<TextProps>)
